// extracted by mini-css-extract-plugin
export default {"root":"Info-root-c87f","icon":"Info-icon-bde5","content":"Info-content-b9a9"};